module.exports = __webpack_public_path__ + "img/compact.5ff58d0b.png";